import i18n from 'modules/core/lib/i18n'

import { Country } from 'modules/legal_entities/lib/constants'
import { IdValidationStrategy, IdentificationType } from 'modules/legal_entities/lib/types'

import globalizeStrategy from '../globalize'
import FranceIdValidationStrategy from './france'
import { FranceIdType } from './france/idType'
import GermanyIdValidationStrategy from './germany'
import { GermanyIdType } from './germany/idType'
import ItalyIdValidationStrategy from './italy'
import { ItalyIdType } from './italy/idType'
import SpainIdValidationStrategy from './spain'
import { SpainIdType } from './spain/idType'

class DefaultIdValidationStrategy implements IdValidationStrategy {
  isValid() {
    return true
  }
  errors() {
    return ''
  }
}

class InvalidIdTypeIdValidationStrategy implements IdValidationStrategy {
  isValid() {
    return false
  }
  errors() {
    return i18n.t('employee_form.choose_identifier_type')
  }
}

const idValidationStrategies = (
  country: Country,
  idType: IdentificationType,
  id: string,
  idLabel: string
) => {
  // Use the globalizeStrategy to select the appropriate validation strategy

  if (!Object.values(Country).includes(country)) {
    return new DefaultIdValidationStrategy()
  }

  if (!id) {
    return new DefaultIdValidationStrategy()
  }

  if (!idType) {
    return new InvalidIdTypeIdValidationStrategy()
  }
  const result = globalizeStrategy({
    default: new DefaultIdValidationStrategy(),
    country: country,
    countries: {
      [Country.Spain]: new SpainIdValidationStrategy(idType as SpainIdType, id, idLabel),
      [Country.France]: new FranceIdValidationStrategy(idType as FranceIdType, id, idLabel),
      [Country.Germany]: new GermanyIdValidationStrategy(idType as GermanyIdType, id, idLabel),
      [Country.Italy]: new ItalyIdValidationStrategy(idType as ItalyIdType, id, idLabel),

      // add more countries
    },
  })
  return result
}

export default idValidationStrategies
